import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-go-overview-step-one',
    imports: [],
    templateUrl: './go-overview-step-one.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['../../go-overview.component.scss'],
})
export class GoOverviewStepOneComponent {}
